export const BeneficiaryEvent = {
  CLEAR_SELECTED_BENEFICIARIES: 'BeneficiaryEvent:CLEAR_SELECTED_BENEFICIARIES',
  INVALIDATE_BENEFICIARY_DETAIL_CACHE: 'BeneficiaryEvent:INVALIDATE_BENEFICIARY_DETAIL_CACHE',
  SAVE_BENEFICIARY: 'BeneficiaryEvent:SAVE_BENEFICIARY'
};
